var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"countdown"},[_c('span',{attrs:{"time":_vm.formatCountdown(_vm.timeDiff)}},[_vm._v(_vm._s(_vm.formatCountdown(_vm.timeDiff)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }